import { Component } from "react";
import {
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import classnames from "classnames";
import {
  createReport,
  getCountryIndustryReportsList,
  deleteReport,
  editReport
} from "./action";
import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";

export class CountryIndustryReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
      addModal: false,
      isEdit: false,
      editId: null,
      reportTitle: "",
      publicationName: "",
      reportDate: "",
      reportFile: null,
      existingFileName: "",
      deleteModal: false,
      deleteId: null,
      deleteTitle: "",
      page: 0,
      size: 10,
    };
  }

  componentDidMount() {
    this.loadReports(0, "1");
  }


  loadReports = (page, tab = this.state.activeTab) => {
    const publicationType =
      tab === "1" ? "COUNTRY" : "INDUSTRY";

    this.props.getCountryIndustryReportsList({
      publicationType,
      page,
      size: this.state.size,
    });

    this.setState({ page });
  };


  handleTabChange = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab, page: 0 });
      this.loadReports(0, tab);
    }
  };


  handleEdit = (row) => {
    this.setState({
      addModal: true,
      isEdit: true,
      editId: row.id,
      reportTitle: row.reportTitle,
      publicationName: row.publicationName,
      reportDate: row.reportDate,
      reportFile: null,
      existingFileName: row.s3Key || "",
    });
  };

  handleDelete = (row) => {
    this.setState({
      deleteModal: true,
      deleteId: row.id,
      deleteTitle: row.reportTitle,
    });
  };

  confirmDelete = () => {
    const publicationType =
      this.state.activeTab === "1" ? "COUNTRY" : "INDUSTRY";

    this.props.deleteReport({
      id: this.state.deleteId,
      publicationType,
    });

    this.setState({
      deleteModal: false,
      deleteId: null,
      deleteTitle: "",
    });
  };

  toggleAddModal = () => {
    this.setState(prevState => ({
      addModal: !prevState.addModal,
      isEdit: false,
      editId: null,
      reportTitle: "",
      publicationName: "",
      reportDate: "",
      reportFile: null,
      existingFileName: "",
    }));
  };


  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleFileChange = (e) => {
    const file = e.target.files[0];
    this.setState({
      reportFile: file,
      existingFileName: file?.name || ""
    });
  };

  handleSubmit = () => {
    const {
      reportTitle,
      reportDate,
      reportFile,
      activeTab,
      publicationName,
      isEdit,
      editId,
    } = this.state;

    if (!reportTitle || !reportDate || !publicationName) {
      alert("All fields required");
      return;
    }


    const publicationType = activeTab === "1" ? "COUNTRY" : "INDUSTRY";

    if (isEdit) {
      this.props.editReport({
        id: editId,
        file: reportFile ? reportFile : "",
        reportTitle,
        reportDate,
        publicationName,
        publicationType,
      });
    } else {
      this.props.createReport({
        file: reportFile,
        reportTitle,
        reportDate,
        publicationName,
        publicationType,
      });
    }

    this.setState({
      addModal: false,
      isEdit: false,
      editId: null,
      reportTitle: "",
      publicationName: "",
      reportDate: "",
      reportFile: null,
      existingFileName: "",
    });
  };

  toggleDeleteModal = () => {
    this.setState(prev => ({ deleteModal: !prev.deleteModal }));
  };

  render() {
    const { activeTab } = this.state;

    return (
      <Col className="px-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0">Country & Industry Reports</h4>
          <Button color="primary" onClick={this.toggleAddModal}>
            + Add Report
          </Button>
        </div>


        {/* Tabs */}
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "1" })}
              onClick={() => this.handleTabChange("1")}
              style={{ cursor: "pointer" }}
            >
              Country Reports
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "2" })}
              onClick={() => this.handleTabChange("2")}
              style={{ cursor: "pointer" }}
            >
              Industry Reports
            </NavLink>
          </NavItem>
        </Nav>

        {/* Tab Content */}
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <Table bordered hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Publication Name</th>
                  <th>Report Title</th>
                  <th>Month & Year</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {this.props.reports.length === 0 && (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No data found
                    </td>
                  </tr>
                )}

                {this.props.reports.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>

                    <td>{item.publicationName}</td>

                    <td>{item.reportTitle}</td>

                    <td> {new Date(item.reportDate).toLocaleDateString("en-US", {
                      month: "long",
                      year: "numeric",
                    })}</td>

                    <td>
                      <Button
                        size="sm"
                        color="warning"
                        className="me-2"
                        onClick={() => this.handleEdit(item)}
                      >
                        Edit
                      </Button>

                      <Button
                        style={{ marginLeft: 10 }}
                        size="sm"
                        color="danger"
                        onClick={() => this.handleDelete(item)}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="d-flex justify-content-end align-items-center mt-3">
              <Button
                size="sm"
                disabled={this.state.page === 0}
                onClick={() => this.loadReports(this.state.page - 1)}
              >
                Prev
              </Button>

              <span className="mx-3">
                Page {this.state.page + 1} of{" "}
                {Math.ceil(this.props.total / this.state.size)}
              </span>

              <Button
                size="sm"
                disabled={(this.state.page + 1) * this.state.size >= this.props.total}
                onClick={() => this.loadReports(this.state.page + 1)}
              >
                Next
              </Button>
            </div>



          </TabPane>

          <TabPane tabId="2">
            <Table bordered hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Publication Name</th>
                  <th>Report Title</th>
                  <th>Month & Year</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {this.props.reports.length === 0 && (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No data found
                    </td>
                  </tr>
                )}

                {this.props.reports.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>

                    <td>{item.publicationName}</td>

                    <td>{item.reportTitle}</td>

                    <td> {new Date(item.reportDate).toLocaleDateString("en-US", {
                      month: "long",
                      year: "numeric",
                    })}</td>

                    <td>
                      <Button
                        size="sm"
                        color="warning"
                        className="me-2"
                        onClick={() => this.handleEdit(item)}
                      >
                        Edit
                      </Button>

                      <Button
                        style={{ marginLeft: 10 }}
                        size="sm"
                        color="danger"
                        onClick={() => this.handleDelete(item)}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="d-flex justify-content-end align-items-center mt-3">
              <Button
                size="sm"
                disabled={this.state.page === 0}
                onClick={() => this.loadReports(this.state.page - 1)}
              >
                Prev
              </Button>

              <span className="mx-3">
                Page {this.state.page + 1} of{" "}
                {Math.ceil(this.props.total / this.state.size)}
              </span>

              <Button
                size="sm"
                disabled={(this.state.page + 1) * this.state.size >= this.props.total}
                onClick={() => this.loadReports(this.state.page + 1)}
              >
                Next
              </Button>
            </div>



          </TabPane>
        </TabContent>

        <Modal isOpen={this.state.addModal} toggle={this.toggleAddModal}>
          <ModalHeader toggle={this.toggleAddModal}>
            {this.state.isEdit ? "Edit Report" : "Add Report"}
          </ModalHeader>

          <ModalBody>
            <Form>
              <FormGroup>
                <Label>Report Title</Label>
                <Input
                  type="text"
                  name="reportTitle"
                  value={this.state.reportTitle}
                  onChange={this.handleInputChange}
                  placeholder="Enter title"
                />
              </FormGroup>

              <FormGroup>
                <Label>Publication Name</Label>
                <Input
                  type="text"
                  name="publicationName"
                  value={this.state.publicationName}
                  onChange={this.handleInputChange}
                  placeholder="Enter publication name"
                />
              </FormGroup>

              <FormGroup>
                <Label>Report Date</Label>
                <Input
                  type="date"
                  name="reportDate"
                  value={this.state.reportDate}
                  onChange={this.handleInputChange}
                />
              </FormGroup>

              <FormGroup>
                <Label>{this.state.isEdit && this.state.existingFileName ? "Uploaded File" : "Upload File"}</Label>

                {this.state.isEdit && this.state.existingFileName && (
                  <div className="mb-2 text-muted">
                    Current file: <b>{this.state.existingFileName}</b>
                  </div>
                )}
                <Input
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={this.handleFileChange}
                />
              </FormGroup>

            </Form>
          </ModalBody>

          <ModalFooter>
            <Button color="secondary" onClick={this.toggleAddModal}>
              Cancel
            </Button>

            <Button color="primary" onClick={this.handleSubmit}>
              {this.state.isEdit ? "Update" : "Submit"}
            </Button>

          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.deleteModal}
          toggle={this.toggleDeleteModal}
        >
          <ModalHeader toggle={this.toggleDeleteModal}>
            Confirm Delete
          </ModalHeader>

          <ModalBody>
            Are you sure you want to delete
            <b> "{this.state.deleteTitle}" </b> ?
          </ModalBody>

          <ModalFooter>
            <Button color="secondary" onClick={this.toggleDeleteModal}>
              Cancel
            </Button>

            <Button color="danger" onClick={this.confirmDelete}>
              Delete
            </Button>
          </ModalFooter>
        </Modal>

        <ToastContainer position="top-right" autoClose={3000} />
      </Col>
    );
  }
}

const mapStateToProps = (state) => ({
  reports: state.countryIndustryReports?.rows || [],
  total: state.countryIndustryReports?.total || 0,
});

const mapDispatchToProps = {
  getCountryIndustryReportsList,
  createReport,
  deleteReport,
  editReport
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CountryIndustryReports);

